import http from "@/http/aisea/axios";
const resource = "/enterprises/vessels";

export default {
  fetch(enterpriseVesselId) {
    return http.get(`${resource}/${enterpriseVesselId}/containers/pictures`);
  },
};
